import { LayerParams } from "../map/layer-manager";
import { ColorType } from "../models/color-type";
import { NormalizerAux } from "../services/normalizer-aux/normalizer-aux";
import * as d3 from "d3";

/**
 * Estratégia de pintura de elementos que são exibidos no mapa, p. ex.,
 * estações, vias, rios, etc.
 */
export class PaintStrategy {

  static factory(layerParams: LayerParams) {

    const { colorType } = layerParams;

    if (colorType == ColorType.CONTINUOUS) {
      return PaintStrategy.continuous(layerParams);
    }
    if (colorType == ColorType.DISCRETE) {
      return PaintStrategy.discrete(layerParams);
    }
    return PaintStrategy.constant(layerParams);
  }

  static continuous(layerParams: LayerParams) {

    const { middleIndicesPluv } = layerParams;

    const normalizer = NormalizerAux.createNormalizer(
      middleIndicesPluv, (rainVal: number) => rainVal
    );

    const continuousPainter = (elemVal: number) => {

      let lowerPercentileVal = middleIndicesPluv[0];
      let upperPercentileVal = middleIndicesPluv[middleIndicesPluv.length - 1];

      if (elemVal == 0){
        return '#FFF';
      }
      if(elemVal < lowerPercentileVal) {
        return d3.interpolateBlues(0);
      }
      if(elemVal > upperPercentileVal) {
        return d3.interpolateBlues(1);
      }
      // entre os valores inferior e superior
      return d3.interpolateBlues(normalizer(elemVal));
    };

    return continuousPainter;
  }

  static discrete(layerParams: LayerParams) {

    const { selectedTimestamp } = layerParams;

    const multipliers: {[key: string]: number} = {
      'indice_pluv': 1/4,
      'quinzemin': 1/4,
      'trintamin': 1/2,
      'umahora': 1,
      'seishoras': 6,
      'dozehoras': 12,
      'vintequatrohoras': 24,
      'quarentaoitohoras': 48,
      'setentaduashoras': 72,
      'noventaseishoras': 96,
      'mes': 720
    };

    const rainThresholds = [ 2.5, 10, 50 ];
    const discreteColors = ['#339944', '#FFCC00', '#FF8822', '#DD2233'];

    const discretePainter = (elem: number) => {

      if (elem < rainThresholds[0] * multipliers[selectedTimestamp]) {
        return discreteColors[0];
      }
      if (elem < rainThresholds[1] * multipliers[selectedTimestamp]) {
        return discreteColors[1];
      }
      if (elem < rainThresholds[2] * multipliers[selectedTimestamp]) {
        return discreteColors[2];
      }
      return discreteColors[3];
    };

    return discretePainter;
  }

  static constant(layerParams: LayerParams) {
    return (elem: number) => '#808080';
  }
}